import { orgRequest } from '@/api/orgClient'
import type { OrgListItem } from '@/lib/orgSpaces'

/**
 * 当前账号已加入的空间。对齐 org-console `GET /org/main/list`。
 * 走 `VITE_ORG_API_BASE_URL`（本地 `/org-api/v1`）。`status=0` 拉全量，由调用方筛 active。
 */
export function listMyOrgs() {
  return orgRequest<{ list?: OrgListItem[] }>('/org/main/list', {
    params: { status: 0 },
  })
}
